import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LaundryLogin from "./components/LaundryLogin";
import AdminDashboard from "./components/AdminDashboard";
 import StudentDashboard from "./pages/StudentDashboard";
import LaundryPage from "./pages/LaundryPage";    
import TrackOrder from "./pages/TrackOrder";
import HistoryPage from "./pages/HistoryPage";
import Profile from "./pages/Profile";
import BagTag from "./pages/BagTag";
import QRLogin from "./pages/QRLogin";



import Report from "./pages/Report";
import Feedback from "./pages/Feedback";

import AdminLogin from "./components/AdminLogin";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LaundryLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />
         <Route path="/student-dashboard" element={<StudentDashboard />} />
          <Route path="/laundry" element={<LaundryPage />} />
           <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/bagtag" element={<BagTag />} />
          <Route path="/qr-login/:usn" element={<QRLogin />} />

         
         

          <Route path="/report" element={<Report />} />
          <Route path="/feedback" element={<Feedback />} />



        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
